module.exports = __webpack_public_path__ + "img/download_app.3cb1d797.png";